/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useCallback, useRef, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { reject } from 'lodash';
import clsx from 'clsx';

import { useSetTableColumnOverrides, useTableColumnOverrides } from '../TableState';
import { useThrottled, useDocumentEvent } from '../../../utilities/Hooks';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        cursor: 'col-resize',
        top: 0,
        bottom: 0,
        right: 0,
        width: 6,

        backgroundColor: theme.palette.primary.light,

        opacity: 0.1,
        transition: 'opacity 0.2s ease',

        '&:hover, &$dragging': {
            opacity: 0.2,
            display: 'block',
        },
    },

    dragging: {},
}));

export default function ColumnWidthAdjuster(props) {
    const { column, className } = props;
    const classes = useStyles();

    const columnOverrides = useTableColumnOverrides();
    const setColumnOverrides = useSetTableColumnOverrides();
    const [isDragging, setIsDragging] = useState(false);

    // this function adjusts the current column's width by applying a delta to it
    const modifyColumnWidth = useThrottled(
        useCallback(
            (width) => {
                const { id, minWidth = 100, maxWidth = 400 } = column;
                width = Math.min(Math.max(minWidth, width), maxWidth);
                setColumnOverrides([...reject(columnOverrides, { id }), { id, width }]);
            },
            [column, columnOverrides, setColumnOverrides]
        ),
        10
    );

    const dragRef = useRef(); // used to identify whether or not we are resizing

    const onMouseMove = useCallback(
        (event) => {
            // if we're dragging...
            if (dragRef.current) {
                const { initialWidth, startPos } = dragRef.current;
                const delta = event.clientX - startPos;
                modifyColumnWidth(initialWidth + delta);
            }
        },
        [modifyColumnWidth]
    );

    // global listeners since target won't be our dragging element
    useDocumentEvent('mouseup', () => {
        setIsDragging(false);
        dragRef.current = null;
    });

    useDocumentEvent('mousemove', onMouseMove);

    const onMouseDown = useCallback(
        (event) => {
            if (event.preventDefault) event.preventDefault();

            setIsDragging(true);

            dragRef.current = {
                initialWidth: column.width,
                startPos: event.target.getBoundingClientRect().x,
            };
        },
        [column.width]
    );

    return <div className={clsx(className, classes.root, isDragging && classes.dragging)} onMouseDown={onMouseDown} />;
}
